<template>
  <v-card>
    <!-- <v-card-title>
      <v-btn @click="goBack" small color="secondary">&lt; Back to Accts</v-btn>
    </v-card-title> -->
    <v-divider></v-divider>
    <v-card-title class="c-title">
      <strong>Transactions: {{ `${account.acctCode} - ${account.bank}` }}</strong>

      <!-- <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field> -->
    </v-card-title>
    <v-data-table
      fixed-header
      :headers="headers"
      :items="accountTransactions"
      :search="search"
      no-data-text="Currently no transactions to display. . ."
    >
      <template slot="item.bank" slot-scope="item">
        <v-chip
          @click="showTransactionDetail(item.item)"
          class="account-name"
          color="warning darken-1 text--lighten"
          label
        >
          <v-icon x-small left>mdi-cash-register</v-icon>
          {{ `(${item.item.rid})` }}
        </v-chip>
      </template>
      <template slot="item.amount" slot-scope="item">{{ floatString(item.item.amount) }}</template>
    </v-data-table>
    <transaction-detail-component
      v-show="curTransaction"
      ref="tdc"
      :transaction="curTransaction"
    ></transaction-detail-component>
  </v-card>
</template>

<script>
import TransactionDetailComponent from "@/components/TransactionDetailComponent";

export default {
  name: "account-transactions-component",
  mounted() {
    console.log("MOUNTED ACCOUNT TRANSACTIONS:", this.account);
  },
  data() {
    return {
      curTransaction: null,
      search: "",
      headers: [
        {
          text: "Transaction",
          align: "start",
          sortable: false,
          value: "bank",
        },
        // { text: "Reason", value: "reason", sortable: false },
        { text: "Code", value: "txnCode", sortable: true },
        { text: "Amount", value: "amount", sortable: true },
        { text: "Status", value: "transferStatus", sortable: true },
        { text: "Recon", value: "reconStatus", sortable: true },
      ],
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    showTransactionDetail(transaction) {
      this.curTransaction = transaction;
      this.$refs.tdc.dialog = true;
    },

    isPortrait() {
      return this.isPortrait();
    },
  },
  props: {
    account: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    accountTransactions() {
      // return this._.get(this.account, "data.transactions", []);
      return this._.get(this.account, "transactions", []).filter((trans) => {
        // return !(trans.originalSource == "bankDetail" && trans.reconStatus != "UNRECON");
        return trans.originalSource != "bankDetail" || trans.reconStatus == "UNRECON";
      });
    },
  },
  components: {
    TransactionDetailComponent,
  },
};
</script>

<style lang="postcss">
.v-tabs {
  border-radius: 0px !important;
}

.account-name {
  color: white !important;
  font-weight: 400;
}

.v-data-table__mobile-row__header {
  margin-right: 20px !important;
}

@media screen and (orientation: portrait) {
  .portrait-totals {
    display: table-row;
  }

  .portrait-totals td {
    background-color: #777 !important;
    color: whitesmoke !important;
    font-weight: bold !important;
  }

  .landscape-totals {
    display: none !important;
  }
}

@media screen and (orientation: landscape) {
  .c-title {
    display: flex !important;
    flex-direction: column !important;
  }
  .landscape-totals {
    display: table-row;
  }
  .portrait-totals {
    display: none !important;
  }
}
</style>
